export class Dialog {
    mensaje: string;
    titulo: string;
    btnSi: string;
    btnNo: string;
}